import React from 'react';
import useDebugInformation from '../../../../../../../../../hooks/useDebugInformation';
import { useAppSelector } from "@store/hooks";
import SquareCardElement from './SquareCardElement';
import SuccessNotice from './SuccessNotice';

const SquareTab: React.FC<{ parent: string }> = ({ parent }) => {
    const bookingCardSecured = useAppSelector(({ ui }) => ui.BookingCardSecured)

    useDebugInformation(`${parent}▷[SquareTab]`, { bookingCardSecured })
    return (
        !bookingCardSecured
            ? <SquareCardElement />
            : <SuccessNotice />)
}

export default React.memo(SquareTab)